const common = {
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    search: '搜索漫画...',
    allCategories: '全部分类',
  },
  home: {
    heroTitle: '全职法师',
    heroSubtitle: '在线免费阅读漫画全集',
    heroDesc: '无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中',
    heroCta: '开始阅读',
    heroBrowse: '浏览分类',
    featuredTitle: '热门',
    featuredTitleHighlight: '推荐',
    latestTitle: '最新更新',
    latestSubtitle: '每周持续更新，精彩不容错过',
    readNow: '立即阅读',
    viewAll: '查看全部',
  },
  category: {
    title: '漫画分类',
    subtitle: '探索你喜欢的漫画类型',
    all: '全部',
  },
  comic: {
    chapters: '章节列表',
    latestChapter: '最新话',
    author: '作者',
    status: '状态',
    ongoing: '连载中',
    completed: '已完结',
    description: '作品简介',
    startReading: '开始阅读',
    continueReading: '继续阅读',
    prevChapter: '上一话',
    nextChapter: '下一话',
    backToList: '返回目录',
    chapterList: '目录',
    tags: '标签',
  },
  about: {
    title: '关于八仔漫画网',
    subtitle: '专注提供高品质漫画阅读体验',
    brandIntro: '品牌介绍',
    brandDesc: '八仔漫画网成立于2020年，是国内领先的免费漫画在线阅读平台。我们致力于为漫画爱好者提供高品质、无广告的纯净阅读体验。平台汇集了热血、玄幻、修真、都市、科幻等各类热门漫画资源，每日持续更新，让读者随时随地畅享精彩漫画世界。',
    reputation: '用户口碑',
    contact: '联系我们',
    contactEmail: '电子邮箱',
    contactWechat: '微信公众号',
    contactDesc: '如有任何建议或合作意向，欢迎通过以下方式联系我们',
  },
  footer: {
    about: '关于我们',
    help: '帮助中心',
    legal: '法律声明',
    follow: '关注我们',
    brandDesc: '八仔漫画网 — 专注于提供高品质免费漫画在线阅读体验。无广告、无付费，纯净阅读环境。',
    copyright: '© 2026 八仔漫画网 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
    contact: '联系我们',
    faq: '常见问题',
    feedback: '用户反馈',
  },
  breadcrumb: {
    home: '首页',
  },
  seo: {
    homeTitle: '八仔漫画网 - 全职法师漫画在线免费阅读漫画全集',
    homeDesc: '八仔漫画网在线免费阅读全职法师漫画全集，无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。',
    categoryTitle: '漫画分类 - 八仔漫画网',
    categoryDesc: '浏览八仔漫画网全部漫画分类，热血、玄幻、修真、都市、科幻等多种类型漫画免费在线阅读。',
    aboutTitle: '关于我们 - 八仔漫画网',
    aboutDesc: '了解八仔漫画网品牌故事与发展历程，国内领先的免费漫画在线阅读平台。',
  },
};

export default common;